export const NOTIFICATION_TYPE_INFO = "info";
export const NOTIFICATION_TYPE_WARNING = "warning ";
export const NOTIFICATION_TYPE_ERROR = "error";
export const NOTIFICATION_TYPE_SUCCESS = "success";
